import {
  GET_ITEM_SHIPPING_FEES,
  GET_ITEM_SHIPPING_FEES_SUCCESS,
  GET_ITEM_SHIPPING_FEES_FAIL,
  GET_ITEM_SHIPPING_FEE_BY_ID_SUCCESS,
  UPDATE_ITEM_SHIPPING_FEE,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const itemShippingFee = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_ITEM_SHIPPING_FEE:
      return {
        ...state,
        loading: true,
      };

    case GET_ITEM_SHIPPING_FEES:
      return {
        ...state,
        loading: true,
      };
    case GET_ITEM_SHIPPING_FEES_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_ITEM_SHIPPING_FEE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };
    case GET_ITEM_SHIPPING_FEES_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default itemShippingFee;
